import { graphql } from "@/gql"
import { WithdrawApplicationDocument } from "@/gql/graphql"
import { DocumentNode, useMutation } from "@apollo/client"
import { toast } from "@/components/Toast"

graphql(`
  mutation WithdrawApplication($applicationId: ID!) {
    withdrawJobApplication(input: { id: $applicationId }) {
      ok
      jobApplication {
        id
        status
        jobPosting {
          id
          applicationCount
        }
      }
    }
  }
`)

export function useWithdrawApplicationMutation({
  applicationId,
  onComplete,
  refetchQueries,
}: {
  applicationId: string
  refetchQueries: DocumentNode[]
  onComplete?: () => void
}) {
  const [withdrawApplication, { loading }] = useMutation(WithdrawApplicationDocument)

  const handleWithdrawApplication = () => {
    withdrawApplication({
      variables: { applicationId },
      refetchQueries,
    })
      .then(() => {
        toast.success("Application withdrawn")
        onComplete?.()
      })
      .catch(() => {
        toast.error("Failed to withdraw application")
      })
  }

  return { handleWithdrawApplication, loading }
}
